function recognizedItems(native) {
  return {
    [Symbol.asyncIterator]() {
      var queue = [];
      var waiting = [];
      var ended = false;
      var canceled = false;
      var end = function end2() {
        ended = true;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
        try {
          for (var _iterator = waiting.splice(0)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var resolve = _step.value;
            resolve({
              done: true,
              value: void 0
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      };
      var id = native.subscribeRecognizedItems(function(items) {
        if (ended) return;
        var resolve = waiting.shift();
        if (resolve) resolve({
          done: false,
          value: items
        });
        else queue.push(items);
      }, end);
      return {
        next() {
          var value = queue.shift();
          if (value) return Promise.resolve({
            done: false,
            value
          });
          if (ended) return Promise.resolve({
            done: true,
            value: void 0
          });
          return new Promise(function(resolve) {
            return waiting.push(resolve);
          });
        },
        async return() {
          queue.length = 0;
          end();
          if (!canceled) {
            canceled = true;
            native.unsubscribeRecognizedItems(id);
          }
          return {
            done: true,
            value: void 0
          };
        }
      };
    }
  };
}
export {
  recognizedItems
};
//# sourceMappingURL=recognizedItems.js.map
